<template>
  <div>
    <div class="newRow" style="display: flex">
      <h4 style="margin-right: 25px; line-height: 32px">
        Additional Information
      </h4>
    </div>
    <el-row v-for="(item, index) in Remarks" :key="index">
      <el-col :span="12">{{ item.label }}</el-col>
      <el-col :span="12" class="text-right">
        <div
          style="margin-bottom: 3px; padding-right: 5px"
          v-if="showOperation(item.type)"
        >
          <div v-if="editTag == item.type">
            <el-button link style="margin-left: 5px" @click="Save">
              <span
                style="
                  padding: 4px 5px;
                  border: 1px solid #00bf9a;
                  border-radius: 6px;
                  color: #00bf9a;
                "
                ><el-icon class="matrix-icon-save"></el-icon></span
            ></el-button>
            <el-button link style="margin-left: 5px" @click="Close">
              <span
                style="
                  padding: 4px 5px;
                  border: 1px solid #ff080a;
                  border-radius: 50%;
                  color: #fff;
                  background-color: #ff080a;
                "
                ><el-icon class="matrix-icon-close"></el-icon></span
            ></el-button>
          </div>
          <div v-else>
            <el-button link @click="Edit(item.type)">
              <span
                style="
                  padding: 4px 5px;
                  border: 1px solid rgb(151, 151, 151);
                  border-radius: 6px;
                "
                ><el-icon class="matrix-icon-search"></el-icon
              ></span>
            </el-button>
            <el-button
              link
              style="margin-left: 5px"
              @click="OpenMailDialog(item.type)"
            >
              <span
                style="
                  padding: 4px 5px;
                  border: 1px solid #fd8a3e;
                  border-radius: 50%;
                  background-color: #fd8a3e;
                "
                ><el-icon
                  class="matrix-icon-mail"
                  style="color: #fff"
                ></el-icon></span
            ></el-button>
          </div>
        </div>
      </el-col>
      <el-col
        ><el-input
          type="textarea"
          :row="5"
          v-model="Remarks[index].description"
          :disabled="!(editTag == item.type)"
        ></el-input
      ></el-col>
      <el-col :span="6">Update By: {{ item.update_by_name }}</el-col>
      <el-col :span="10"
        >Date: {{ formatter_datetime(item.update_time) }}</el-col
      >
      <el-col :span="24">
        <div class="remark-br"></div>
      </el-col>
    </el-row>
  </div>
  <!-- email dialog -->
  <el-dialog title="" v-model="showEmailDialog" width="800">
    <el-row :gutter="10">
      <el-col :span="24">
        <div style="width: 100%; display: flex">
          <div style="width: 40px; text-align: right; padding-right: 10px">
            <span class="text-error" style="padding-right: 3px">*</span>To:
          </div>
          <div style="flex-grow: 1">
            <el-input
              v-model="EmailTo"
              :class="{
                'text-error':
                  validate_results.filter((t) => t.field == 'sendTo')?.length >
                  0,
              }"
            ></el-input>
            <div class="text-error">
              Please separate email addresses with semicolons
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <div style="width: 100%; display: flex">
          <div style="width: 40px; text-align: right; padding-right: 10px">
            CC:
          </div>
          <div style="flex-grow: 1">
            <el-input
              v-model="EmailCC"
              :class="{
                'text-error':
                  validate_results.filter((t) => t.field == 'sendCC')?.length >
                  0,
              }"
            ></el-input>
            <div class="text-error">
              Please separate email addresses with semicolons
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24" class="text-right">
        <base-button type="primary" @click="Send">Send</base-button>
        <base-button @click="showEmailDialog = false">Close</base-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script setup>
import { ElMessage } from 'element-plus';
import { ref, onMounted } from 'vue';
import contractnet from '@/network/contractnet';
import { formatter_datetime } from '@/assets/js/formatter.js';
import { useContractStore } from '@/store/contract';
import BaseButton from '@/components/newUI/BaseButton.vue';
import validation from '@/assets/js/validation.js';
import { request } from '@/network/request';

const props = defineProps({
  contract_id: {
    type: String,
    description: '合同guid',
  },
  additional_info: {
    type: Object,
    description: '附加信息',
  },
});

const Remarks = ref([]);
const showEmailDialog = ref(false);
const EmailTo = ref();
const EmailCC = ref();

// 邮箱验证
const EmailReg = new RegExp('^([a-zA-Z0-9_\\-\\.]+)@asiaray.(cn|hk)$');

const validate_rules = {
  sendTo: [
    {
      required: true,
      message: 'Please fill in mandatory field!',
    },
    {
      message: 'Invalid email address.',
      validator(rule, value) {
        if (value) {
          var values = value.split(';').filter((t) => t?.replaceAll(' ', ''));

          if (values?.length > 0) {
            values = values.map((t) => t.replaceAll(' ', ''));
          }

          console.log('values: ', values);
          for (var i = 0; i < values.length; i++) {
            if (!EmailReg.test(values[i])) {
              return false;
            }
          }
        }
        return true;
      },
    },
  ],
  sendCC: {
    message: 'Invalid email address.',
    validator(rule, value) {
      if (value) {
        var values = value.split(';').filter((t) => t?.replaceAll(' ', ''));
        for (var i = 0; i < values.length; i++) {
          if (!EmailReg.test(values[i])) {
            return false;
          }
        }
      }
      return true;
    },
  },
};

const validate_results = ref([]);

onMounted(() => {
  var str = JSON.stringify(props.additional_info.remarks);
  Remarks.value = JSON.parse(str);
});

const editTag = ref('');
const notifTag = ref('');

const Edit = (tag) => {
  if (editTag.value) {
    ElMessage({
      message: 'Please complete previous steps first',
      type: 'warning',
    });
    return;
  }
  editTag.value = tag;
};

const Save = async () => {
  var type = editTag.value;
  var remark = JSON.stringify(Remarks.value.find((t) => t.type === type));
  var contract_id = props.contract_id;
  const res_data = await contractnet
    .SaveContractRemark(contract_id, type, remark)
    .then((res) => res.data);
  if (res_data.message && res_data.message !== 'OK') {
    ElMessage({
      message: res_data.message,
      type: 'warning',
    });
    return;
  }

  // var remark_info = Remarks.value.find((t) => t.type === type);
  // Remarks.value[Remarks.value.indexOf(remark_info)] = res_data.data.find(
  //   (t) => t.type == editTag.value
  // );
  editTag.value = '';
  await useContractStore().Init('AdditionalInfo');
  var str = JSON.stringify(props.additional_info.remarks);
  Remarks.value = JSON.parse(str);
};

const Close = () => {
  var remark = props.additional_info.remarks.find(
    (t) => t.type == editTag.value
  )?.description;

  Remarks.value.find((t) => t.type == editTag.value).description = remark;
  editTag.value = '';
};

const showOperation = (type) => {
  console.log('showOperation', type);
  const permissions = props?.additional_info?.permissionActions;
  if (!permissions) return false;

  const operation_permission = permissions.find(
    (t) => t.indexOf('_' + type) >= 0
  );

  const useContract = useContractStore();
  var permission_info = useContract.getContractFunctionPermission(type);
  return permission_info && !permission_info.disable;
};

const OpenMailDialog = (type) => {
  EmailTo.value = '';
  EmailCC.value = '';

  notifTag.value = type;

  validate_results.value = [];
  showEmailDialog.value = true;
};

// 发送邮件
const Send = async () => {
  await ValidMail({
    sendTo: EmailTo.value,
    sendCC: EmailCC.value,
  });

  if (validate_results.value?.length > 0) {
    ElMessage({
      message: validate_results.value[0].message,
      type: 'warning',
    });
    return;
  }

  showEmailDialog.value = false;

  const res = await SendMail().then((res) => res);
  if (res?.data?.message) {
    ElMessage({
      message: res.message,
      type: 'warning',
    });
    return;
  }

  ElMessage({ message: 'Email sent.', type: 'success' });
};

const changeAddress = () => {
  ValidMail({
    sendTo: EmailTo.value.replaceAll(' ', ''),
    sendCC: EmailCC.value.replaceAll(' ', ''),
  });
};

const ValidMail = async (source) => {
  validate_results.value = await validation
    .validate(source, validate_rules)
    .then((err1) => err1);
};

const SendMail = async (type) => {
  var ContractSummary = useContractStore().ContractSummary;

  var remark = Remarks.value.find((t) => t.type == notifTag.value);

  var request_body = {
    ToAddresses: EmailTo.value.split(';').filter((t) => t !== ''),
    CcAddresses: EmailCC.value.split(';').filter((t) => t !== ''),
    TemplateName: 'ContractRemarkNotification',
    messageAttributtes: {
      ContractNumber: ContractSummary.templateContractNumber,
      ContractingParty: ContractSummary.contractParty,
      Advertiser: ContractSummary.advertiserName,
      ProductName: ContractSummary.productName,
      UpdateName: remark?.update_by_name,
      UpdateDate: formatter_datetime(
        remark?.update_time,
        'YYYY-MM-DD HH:mm:ss '
      ),
      Remark: remark?.description,
      ContractLink: `${process.env.VUE_APP_DOMAIN}/contract?cId=${props.contract_id}`,
    },
  };

  await request({
    url: '/admin/SendTemplateMail',
    method: 'post',
    data: request_body,
  });

  notifTag.value = '';
};
</script>
<style scoped>
.remark-br {
  border-bottom: 1px solid #000;
  margin-top: 38px;
  margin-bottom: 10px;
}
.text-error {
  color: var(--el-color-danger);
  line-height: 1;
  padding-top: 5px;
}
</style>
<style>
.text-error.el-input .el-input__wrapper {
  box-shadow: 0 0 0 1px #ec250d !important;
}
</style>
